interface BuildTimeConfig {
	appRoutingBase: string
	env: string
}

const buildTimeConfig: BuildTimeConfig = {
	appRoutingBase: '/auth',
	env: 'production',
}

export default buildTimeConfig;